import { useRef, MouseEvent, useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import { CandidateDashboardInterview } from "../../../models/candidate/response/CandidateDashboardModel";
import candidateClasses from "../../landing-pages/candidate/candidate.module.css";
import dateUtils from "../../../utils/date-utils";
import { Button } from "@mui/material";

interface CandidateDashboardRatingProps {
    objCandidateDashboardDetails: CandidateDashboardInterview;
}

const CandidateDashboardInterviewComponent = (props: CandidateDashboardRatingProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [candidateDashboardDetails, setCandidateDashboardDetails] = useState<CandidateDashboardInterview>(props.objCandidateDashboardDetails);
    return (
        <div>
            <div className="row">
                <div className="col-lg-4 col-md-4 user-label">Date:</div>
                <div className="col-lg-8 col-md-8">{candidateDashboardDetails.interviewDateString}</div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-4 user-label">Time:</div>
                <div className="col-lg-8 col-md-8">{candidateDashboardDetails.timeSlotName}</div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-4 user-label">Skills:</div>
                <div className="col-lg-8 col-md-8">{candidateDashboardDetails.secondarySkillName}</div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-4 user-label"> Interviewer:</div>
                <div className="col-lg-8 col-md-8">{candidateDashboardDetails.interviewerName}</div>
            </div>
            {!candidateDashboardDetails.isRated &&
                <div className="row">
                    <div className="col-md-12 join-meeting-wrapper">
                        <Button variant="outlined" color="primary" href={candidateDashboardDetails.zoomMeetingUrl} target="_blank" rel="noopener noreferrer" title={candidateDashboardDetails.zoomMeetingUrl}>
                            Join Meeting
                        </Button>
                    </div>
                </div>
            }
        </div>
    );
};
export default CandidateDashboardInterviewComponent;